import Box from "@material-ui/core/Box";
import TrophyFilled16 from "@carbon/icons-react/lib/trophy--filled/16";
import { React } from "react";
import TeamMatch from "./TeamMatch";
import matchStyles from "../styles/Match.styles";

const TeamRowHeader = ({ isWinner, isSingle, matchTeam, team }) => {
	const classes = matchStyles();

	return (
		<Box display="flex" alignItems="center">
			<TeamMatch
				team={team}
				isSingle={isSingle}
				playersId={matchTeam.players}
				size="small"
				rank={matchTeam.rank}
				isWinner={isWinner}
				incompleteType={matchTeam.incompleteType}
			/>
			{isWinner && (
				<span className={classes.trophy}>
					<TrophyFilled16 />
				</span>
			)}
		</Box>
	);
};

export default TeamRowHeader;
